import clsx from 'clsx';
import moment from 'moment';
import React from 'react';
export const getCertificateExpiryStatus =
    (expiryTs, uuid, classes, startReportingDays, urgentReportingDays) => {
  if (!expiryTs) {
    return (<span />)
  }
  const expiryTime = moment(expiryTs);
  const currentTime = moment();
  const days = expiryTime.diff(currentTime, 'days');
  let className = classes.normalKey;
  let label = '';
  // string to represent status, which is used by automation
  let expiryStatus;
  label = days;
  if (days <= urgentReportingDays) {
    className = classes.urgentReportingKey;
    expiryStatus = 'urgentReporting';
    if (days < 0) {
      label = 0;
    }
  } else if (days > startReportingDays) {
    className = classes.normalKey;
    expiryStatus = 'normal';
  } else {
    className = classes.startReportingKey;
    expiryStatus = 'startReporting';
  }

  return (
  <span
    data-apim-test={`cert-${uuid}-expiry-status-${expiryStatus}`}
    className={clsx(classes.status, className)}
  >
    {label}
  </span>);
};